module.exports = __webpack_public_path__ + "img/training_2.d3315554.png";